export const legendItems = [
  {
    label: "Present",
    color: "#52A13D",
    letter: "P",
    boxcolor: "#F1FBF0",
  },
  {
    label: "Absent",
    color: "#E12B1D",
    letter: "A",
    boxcolor: "#F9D5D2",
  },
  {
    label: "Leave",
    color: "#6F6D6D",
    letter: "L",
    boxcolor: "#d1d1d1",
  },
  {
    label: "Probationary Leave",
    color: "#6F6D6D",
    letter: "PRL",
    boxcolor: "#d1d1d1",
  },
  {
    label: "Privilege Leave",
    color: "#6F6D6D",
    letter: "PL",
    boxcolor: "#d1d1d1",
  },
  {
    label: "Paternity Leave",
    color: "#6F6D6D",
    letter: "PAL",
    boxcolor: "#d1d1d1",
  },
  {
    label: "Maternity Leave",
    color: "#6F6D6D",
    letter: "ML",
    boxcolor: "#d1d1d1",
  },
  {
    label: "Casual Leave",
    color: "#6F6D6D",
    letter: "CL",
    boxcolor: "#d1d1d1",
  },
  {
    label: "Sick Leave",
    color: "#6F6D6D",
    letter: "SL",
    boxcolor: "#d1d1d1",
  },
  {
    label: "Marriage Leave",
    color: "#6F6D6D",
    letter: "ML",
    boxcolor: "#d1d1d1",
  },
  {
    label: "Bereavement Leave",
    color: "#6F6D6D",
    letter: "BL",
    boxcolor: "#d1d1d1",
  },
  {
    label: "Comp Off",
    color: "#7B6D62",
    letter: "CO",
    boxcolor: "#DFD9D4",
  },
  {
    label: "On Duty",
    color: "#FF5E3A",
    letter: "OD",
    boxcolor: "#FFE4E0",
  },
  {
    label: "Work From Home",
    color: "#90A4AE",
    letter: "WFH",
    boxcolor: "#E3EBED",
  },
  {
    label: "Holiday",
    color: "#092C4C",
    letter: "H",
    boxcolor: "#EEF5FC",
  },
  {
    label: "Restricted Holiday",
    color: "#E3B53E",
    letter: "L",
    boxcolor: "#FEF4DA",
  },
  {
    label: "Regularize Approved",
    color: "#0A0B0A",
    letter: "P",
    boxcolor: "#33DC71",
  },
  {
    label: "Regularize Pending",
    color: "#BB7D17",
    letter: "P",
    boxcolor: "#F7AE34",
  },
  {
    label: "Regularize Rejected",
    color: "#E9E9E9",
    letter: "P",
    boxcolor: "#EC2424",
  },
  {
    label: "OFF Day",
    color: "",
    letter: "OFF",
    boxcolor: "",
  },
];
